import { FilePropertiesValidation } from "../../FilePropertiesValidation";

export class DisabilityData {
    private _hasDisability: boolean;
    private _degree: number;
    private _reserveType: number;
    private _adaptationRequest: string;
    private _reason: string;
    private _autonomousCommunityDisability: number;
    private _disabilityBox: any;

    constructor(data: any) {
        this._hasDisability = data.hasDisability || false;
        this._degree = data.degree;
        this._reserveType = data.reserveType;
        this._adaptationRequest = data.adaptationRequest;
        this._reason = data.reason;
        this._autonomousCommunityDisability = data.autonomousCommunityDisability;
        this._disabilityBox = new FilePropertiesValidation();
    }
    
    public get hasDisability() {
        return this._hasDisability;
    }
    public set hasDisability(hasDisability: any) {
        this._hasDisability = Boolean(JSON.parse(hasDisability));
    }

    public get degree() {
        return this._degree;
    }
    public set degree(degree: number) {
        this._degree = degree;
    }

    public get reserveType() {
        return this._reserveType;
    }
    public set reserveType(reserveType: number) {
        this._reserveType = reserveType;
    }

    public get adaptationRequest() {
        return this._adaptationRequest;
    }
    public set adaptationRequest(adaptationRequest: string) {
        this._adaptationRequest = adaptationRequest;
    }

    public get reason() {
        return this._reason;
    }
    public set reason(reason: string) {
        this._reason = reason;
    }

    public get autonomousCommunityDisability() {
        return this._autonomousCommunityDisability;
    }
    public set autonomousCommunityDisability(autonomousCommunityDisability: number) {
        this._autonomousCommunityDisability = autonomousCommunityDisability;
    }

    public set disabilityBox(disabilityBox: any) {
        this._disabilityBox = disabilityBox;
    }
    public get disabilityBox() {
        return this._disabilityBox;
    }

    public toServer() {
        return {
            hasDisability: this._hasDisability,
            degree: this._degree,
            reserveType: this._reserveType,
            adaptationRequest: this._adaptationRequest,
            reason: this._reason,
            autonomousCommunityDisability: this._hasDisability ? this._autonomousCommunityDisability : null
        };
    }
}
